/**
 * Push Notification Utility
 * Requests permission and shows native browser notifications.
 * Used for stock alerts, new orders, and other real-time events.
 */

export async function requestNotificationPermission(): Promise<boolean> {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;

  const result = await Notification.requestPermission();
  return result === 'granted';
}

export function showNotification(title: string, options?: { body?: string; icon?: string; tag?: string }): void {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;

  new Notification(title, {
    body: options?.body,
    icon: options?.icon || '/pwa-192x192.png',
    tag: options?.tag,
    badge: '/pwa-192x192.png',
  });
}

export function isNotificationSupported(): boolean {
  return 'Notification' in window;
}

export function getNotificationPermission(): NotificationPermission | 'unsupported' {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission;
}
